// extracted by mini-css-extract-plugin
module.exports = {"container":"AddPoints_container__2hnyI","content":"AddPoints_content__1ZgPi"};